import { useState } from 'react';
import { useFilesMutations } from '@common';

export type UseCreateFolderModalMethodsReturnType = {
  opened: boolean;
  onClose: () => void;
  onCreateFolder: (folderName: string) => void;
  openModal: (parentId: string) => void;
};

type UseCreateFolderModalMethodsPropsType = {
  refetchFiles: () => void;
  locationId: string;
};

export const useCreateFolderModalMethods = ({
  refetchFiles,
  locationId,
}: UseCreateFolderModalMethodsPropsType): UseCreateFolderModalMethodsReturnType => {
  const [createFolderParentId, setCreateFolderParentId] = useState<
    string | null
  >(null);

  const { createFolder } = useFilesMutations(refetchFiles);

  const handleCreateFolder = (folderName: string) => {
    if (!createFolderParentId) return;
    createFolder({
      folderName,
      parentId: createFolderParentId,
      locationId,
    });
  };

  return {
    opened: !!createFolderParentId,
    onClose: () => setCreateFolderParentId(null),
    onCreateFolder: handleCreateFolder,
    openModal: setCreateFolderParentId,
  };
};
